import Node from "./Node";

class NodeContact extends Node {
    form = {};

    constructor(id, title, form) {
        super(id, 'contact', title);
        if (form !== undefined) {
            this.form = form;
        }
    }
}

export default NodeContact;